import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.deviceTypeDataInternal ? _c(VContainer, {
    staticClass: "pa-0 devicetype-packetparser",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.duplicateKeys.title'),
      "color": "danger",
      "open": _vm.parserDuplicateKeysPrompt,
      "buttons": [{
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.duplicateKeys.saveAnyway'),
        color: 'danger',
        emit: 'save'
      }, {
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.parserDuplicateKeysPrompt = false;
      },
      "save": function ($event) {
        _vm.parserDuplicateKeysPrompt = false;
        _vm.saveParser();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.duplicateKeys.text')) + "\n      ")]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.unsavedParserTitle'),
      "open": _vm.parserSavePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptConfirm'),
        color: 'danger',
        emit: 'discard-parser'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.parserSavePrompt = false;
      },
      "discard-parser": function ($event) {
        return _vm.unsavePromptNextPersist();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.unsavedParserText')) + "\n      ")]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptTitle'),
      "open": _vm.switchParserPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptConfirm'),
        color: 'danger',
        emit: 'switch-parser'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.switchParserPrompt = false;
      },
      "switch-parser": function ($event) {
        return _vm.switchParserType();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptText')) + "\n      ")]), _c('core-n20Card', {
    staticClass: "dt-card-text-01 px-0 mx-0",
    attrs: {
      "form": _vm.formComponent,
      "buttons": _vm.formCardButtons,
      "title": _vm.parserTypeName,
      "offset": 24
    },
    on: {
      "switch-parser-type": function ($event) {
        _vm.switchParserPrompt = true;
      },
      "submit-form": function ($event) {
        return _vm.saveParserPreflight();
      }
    }
  }, [_vm.deviceTypeParser.type === 'single' ? _c('niota-classic-devicetypes-packet-parser-single', {
    ref: "formComponent",
    attrs: {
      "parserConfig": _vm.deviceTypeParser.config,
      "accountId": _vm.deviceTypeDataInternal.account.id,
      "custom-test-function": _vm.customTestFunction,
      "readonly": _vm.readonly,
      "hide-predefined-parser-selection": _vm.hidePredefinedParserSelection
    },
    on: {
      "config-updated": _vm.parserConfigUpdated
    }
  }) : _vm._e(), _vm.deviceTypeParser.type === 'multi' ? _c('niota-classic-devicetypes-packet-parser-multi', {
    ref: "formComponent",
    attrs: {
      "parserConfig": _vm.deviceTypeParser.config,
      "accountId": _vm.deviceTypeDataInternal.account.id,
      "readonly": _vm.readonly,
      "custom-test-function": _vm.customTestFunction,
      "hide-predefined-parser-selection": _vm.hidePredefinedParserSelection
    },
    on: {
      "config-updated": _vm.parserConfigUpdated
    }
  }) : _vm._e(), _vm.deviceTypeParser.type === 'function' ? _c('niota-classic-devicetypes-packet-parser-function', {
    ref: "formComponent",
    attrs: {
      "parserConfig": _vm.deviceTypeParser.config,
      "accountId": _vm.deviceTypeDataInternal.account.id,
      "readonly": _vm.readonly,
      "custom-test-function": _vm.customTestFunction,
      "call-from-device-type": _vm.callFromDeviceType
    },
    on: {
      "config-updated": _vm.parserConfigUpdated
    }
  }) : _vm._e(), !_vm.deviceTypeDataInternal || _vm.deviceTypeParser.type === 'unset' || !_vm.deviceTypeParser.type ? _c('niota-classic-devicetypes-packet-parser-parser-selector', {
    ref: "formComponent",
    attrs: {
      "parser": _vm.deviceTypeParser,
      "readonly": _vm.readonly
    },
    on: {
      "config-updated": _vm.parserUpdated
    }
  }) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };